// src/context/AppContext.js
import React, { createContext, useContext, useReducer } from 'react';

const initialState = {
    catalogInfo: {
        Form: {
            id: "",
            name: "",
            url: "",
            attributes: {},
        },
        Video: {
            id: "",
            name: "",
            url: "",
        },
        Program: {
            id: "",
            name: "",
            url: "",
            imageUrl: "",
        },
        Degree: {
            id: "",
            name: "",
            url: "",
            imageUrl: "",
        },
        Campus: {
            id: "",
            name: "",
        },
        Module: {
            id: "",
            name: "",
            url: "",
            imageUrl: "",
        },
        Tags: [],
    },
    pageInfo: {
        hasForm: false,
        hasArticle: false,
        hasVideo: false,
        name: "",
        categories: [],
        tags: [],
        catalog: {}
    },
    userInfo: {
        userId: "",
        emailAddress: "",
        sfmcContactKey: "",
        accountId: "",
        loggedIn: false,
        attributes: {},
        firstName: "",
        lastName: "",
        memberType: "guest",
    },
    overlay_open: false,
    overlay_video_url: "",
    overlay_modal_title: "",
    overlay_modal_description: "",
    overlay_modal_brochure_image: "",
    overlay_modal_form: "",
    overlay_modal_form_title: "",
    instagram_post: "",
    instagram_images: "",
    instagram_image: "",
    instagram_video: "",
    instagram_username: "",
    instagram_text: "",
    instagram_like: "",
    instagram_comment: "",
    instagram_timestamp: "",
    instagram_has_video: "",
};

const AppContext = createContext();

const appReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_PAGE_INFO':
            const updatedPageInfo = { ...state.pageInfo, ...action.payload };

            // Check if pageInfo already exists in window.dataLayer
            const pageInfoIndex = window.dataLayer.findIndex(item => item.pageInfo);

            if (pageInfoIndex !== -1) {
                // Update existing pageInfo in window.dataLayer
                window.dataLayer[pageInfoIndex].pageInfo = updatedPageInfo;
            } else {
                // If not present, push the new pageInfo
                window.dataLayer.push({
                    pageInfo: updatedPageInfo,
                });
            }

            // Update the state
            return { ...state, pageInfo: updatedPageInfo };

        case 'UPDATE_CATALOG_INFO':
            return {
                ...state,
                catalogInfo: {
                    ...state.catalogInfo,
                    ...action.payload,
                },
            };
        case 'UPDATE_USER_INFO':
            const updatedUserInfo = { ...state.userInfo, ...action.payload };
            window.dataLayer.push({
                userInfo: updatedUserInfo,
            });
            return { ...state, userInfo: updatedUserInfo };
        default:
            return { ...state, ...action.payload };
    }
};
const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    // Add your logic to push the global state to window.datalayer
    // You can use useEffect or another method to trigger this behavior

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};

const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};

const generatePayload = (type, story) => {
    if (type === "Tags"){
        const basePayload = {
            type: 'UPDATE_CATALOG_INFO',
            payload: {
                Tags: [story.tag_list]
            },
        };
        return basePayload;
    }
    else {
        const basePayload = {
            type: 'UPDATE_CATALOG_INFO',
            payload: {
                [type]: {
                    id: story.uuid,
                    name: story.content.meta_data[0].meta_title.replace(/\s\|\sHult\sInternational\sBusiness\sSchool$/, ""),
                    url: story.full_slug.replace(/^hult\//, "https://www.hult.edu/"),
                    imageUrl: story.content.meta_data[0].og_image.filename
                },
            },
        };
        return basePayload;
    }
};


export { AppProvider, useAppContext, generatePayload, initialState };